import type { MeaterProductVariant } from '@src/domain/types/MeaterProduct';

/**
 * Finds the best variant to navigate to when the user changes one option dimension.
 *
 * Prefers the variant that matches the target option value AND preserves all other
 * currently-selected option values from the active variant. Falls back to the first
 * variant with the target option value if no exact combination exists.
 */
export function findBestVariant(
  variants: Array<MeaterProductVariant>,
  activeVariant: MeaterProductVariant | undefined,
  targetOptionName: string,
  targetOptionValue: string,
): MeaterProductVariant | undefined {
  const otherOptions =
    activeVariant?.selectedOptions.filter(
      (o) => o.name.toLowerCase() !== targetOptionName.toLowerCase(),
    ) ?? [];

  const exactMatch = variants.find((v) => {
    const hasTarget = v.selectedOptions.some(
      (o) =>
        o.name.toLowerCase() === targetOptionName.toLowerCase() && o.value === targetOptionValue,
    );
    const preservesOthers = otherOptions.every((activeOpt) =>
      v.selectedOptions.some(
        (o) => o.name.toLowerCase() === activeOpt.name.toLowerCase() && o.value === activeOpt.value,
      ),
    );
    return hasTarget && preservesOthers;
  });

  return (
    exactMatch ??
    variants.find((v) =>
      v.selectedOptions.some(
        (o) =>
          o.name.toLowerCase() === targetOptionName.toLowerCase() && o.value === targetOptionValue,
      ),
    )
  );
}
